import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Case } from '@secca/shared/models/case';
import { combineLatest } from 'rxjs';
import { TravelInfoService } from '@secca/case/components/case-travel-info/service/travel-info.service';
import { CaseLocalTimeService } from '@secca/case/components/case-local-time/case-local-time.service';
import { AutoUnsubscribe } from '@secca/shared/decorators/auto-unsubscribe';
import { CaseService } from '@secca/core/services/case.service';
import { TravelInfoDto } from '@secca/case/components/case-travel-info/model/travelInfoDto';
import { Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { InsuranceService } from '@secca/core/services/insurance.service';


@AutoUnsubscribe
@Component({
    selector: 'app-case-travel-info',
    templateUrl: './travel-info.component.html',
    styleUrls: ['./travel-info.component.scss'],
    standalone: false
})
export class TravelInfoComponent implements OnChanges {
  @Input() seccaCase: Case;
  travelInfo: TravelInfoDto;
  private displayTravelInfo: boolean;

  private combinedSubscription: Subscription;

  constructor(
    private travelInfoService: TravelInfoService,
    private localTimeService: CaseLocalTimeService,
    private caseService: CaseService,
    private insuranceService: InsuranceService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['seccaCase'];

    if (change && this.seccaCase.caseNumber) {
      this.combinedSubscription?.unsubscribe();
      this.combinedSubscription = this.insuranceService
        .getCustomerProfileInfo(this.seccaCase.id)
        .pipe(
          switchMap(profile =>
            this.caseService.getCustomerProfile(profile.customerProfileId.toString())
          ),
          switchMap(fullProfile =>
            this.localTimeService.getLocalTimeZone().pipe(
              tap(localTimeZone => {
                const countryCodeAlpha2 =
                  localTimeZone?.countryCodeAlpha2 ||
                  this.seccaCase?.incident?.currentCountryCodeAlpha2;
                if (fullProfile?.adtCode === 'ADT04') {
                  this.displayTravelInfo = true;
                  this.updateTravelInfo(countryCodeAlpha2);
                } else {
                  this.displayTravelInfo = false;
                  this.travelInfo = null;
                }
              })
            )
          )
        )
        .subscribe();
    }
  }


  private updateTravelInfo(countryCodeAlpha2: string): void {
    if (countryCodeAlpha2) {
      this.travelInfoService.fetchTravelInfo(countryCodeAlpha2).subscribe({
        next: (travelInfo) => {
          countryCodeAlpha2 !== 'DK' && this.displayTravelInfo ? this.travelInfo = travelInfo : this.travelInfo = null;
        },
        error: (error) => {
          console.error('Error fetching travel info:', error);
          this.travelInfo = null;
        }
      });
    }
  }

  openTravelGuide() {
    window.open(this.travelInfo.sourceUrl, '_blank');
  }
}
